import { render, staticRenderFns } from "./component-ddf36607.vue?vue&type=template&id=3dc14034&scoped=true&"
import script from "./component-ddf36607.vue?vue&type=script&lang=js&"
export * from "./component-ddf36607.vue?vue&type=script&lang=js&"
import style0 from "./component-ddf36607.vue?vue&type=style&index=0&id=3dc14034&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc14034",
  null
  
)

export default component.exports